import { createAsyncThunk } from '@reduxjs/toolkit'
import { API } from '../dataServise'
import { baseURL } from "../../../utils/constants";

const apiUrl = `${baseURL}/service-names`

export const getServiceNames = createAsyncThunk(
  'GET_SERVICE_NAMES',
  async ({page=1}, thunk) => {
    try {
      const { data } = await API.get(`${apiUrl}?page=${page}`)
      return data
    } catch (exception) {
      if (exception.response?.data.message) {
        return thunk.rejectWithValue(exception.response.data.message)
      } else throw exception
    }
  },
)

export const createServiceName = createAsyncThunk(
  'CREATE_SERVICE_NAME',
  async (body, thunk) => {
    try {
      const { data } = await API.post(`${apiUrl}`, body)
      return data
    } catch (exception) {
      if (exception.response?.data.message) {
        return thunk.rejectWithValue(exception.response.data.message)
      } else throw exception
    }
  },
)

export const updateServiceName = createAsyncThunk(
  'UPDATE_SERVICE_NAME',
  async ({id, body}, thunk) => {
    try {
      const { data } = await API.put(`${apiUrl}/${id}`, body)
      return data
    } catch (exception) {
      if (exception.response?.data.message) {
        return thunk.rejectWithValue(exception.response.data.message)
      } else throw exception
    }
  },
)